<template>
  <div class="marker-list-item" :style="{ gap: `${markerTextSpacing !== undefined ? markerTextSpacing : 20}px` }">
    <!-- Явные шаблоны по типам (list-marker-1..4) для наглядной правки -->
    <ListMarkerSymbol v-if="type === ListMarker.One"
                      :style-obj="plainStyle"
                      :mask-style="markerMaskStyle"
                      :src="markerImagePath"
                      :alt="markerType"
                      :marker-vertical-offset="markerVerticalOffset" />

    <ListMarkerSymbol v-else-if="type === ListMarker.Two"
                      :style-obj="plainStyle"
                      :mask-style="markerMaskStyle"
                      :src="markerImagePath"
                      :alt="markerType"
                      :marker-vertical-offset="markerVerticalOffset" />

    <ListMarkerSymbol v-else-if="type === ListMarker.Three"
                      :style-obj="plainStyle"
                      :mask-style="markerMaskStyle"
                      :src="markerImagePath"
                      :alt="markerType"
                      :marker-vertical-offset="markerVerticalOffset" />

    <ListMarkerSymbol v-else-if="type === ListMarker.Four"
                      :style-obj="plainStyle"
                      :mask-style="markerMaskStyle"
                      :src="markerImagePath"
                      :alt="markerType"
                      :marker-vertical-offset="markerVerticalOffset" />

    <!-- fallback -->
    <ListMarkerSymbol v-else
                      :style-obj="plainStyle"
                      :mask-style="markerMaskStyle"
                      :src="markerImagePath"
                      :alt="markerType"
                      :marker-vertical-offset="markerVerticalOffset" />

    <div class="list-item-text" v-if="!labelDisabled">
      <div
        v-if="showTitle && title"
        class="list-item-title"
        v-html="title"
      ></div>
      <VBibleInteractive :html="text ?? ''" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import ListMarkerSymbol from './symbols/ListMarkerSymbol.vue';
import { useMarkerTypes } from '../../composables/markers';
import { ListMarker } from '../../composables/markers';

const props = defineProps<{
  text: string;
  title?: string;
  showTitle?: boolean;
  index: number;
  markerType: string;
  markerColor?: string;
  markerBackgroudColor?: string;
  markerTextColor?: string;
  labelDisabled?: boolean;
  isUseCustomMarkerColor?: boolean;
  markerTextSpacing?: number;
  markerVerticalOffset?: number;
}>();

// Используем композабл для работы с маркерами
const { getMarkerImagePath } = useMarkerTypes();

const markerImagePath = computed(() => {
  return getMarkerImagePath(props.markerType);
});

const type = computed(() => props.markerType);

const base = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  width: '20px',
  height: '20px',
  minWidth: '20px'
} as const;

const resolvedBackground = computed(() => {
  // Використовуємо кастомний колір тільки якщо isUseCustomMarkerColor = true
  if (props.isUseCustomMarkerColor) {
    const custom = (props.markerBackgroudColor || props.markerColor || '').trim();
    if (custom) return custom;
  }
  return 'transparent';
});

const plainStyle = computed(() => {
  return {
    ...base,
  } as any;
});

// Стиль для маски SVG з кольором
const markerMaskStyle = computed(() => {
  const color = resolvedBackground.value;
  if (!color || color === 'transparent') return {};
  
  return {
    background: color,
    WebkitMask: `url(${markerImagePath.value}) center/contain no-repeat`,
    mask: `url(${markerImagePath.value}) center/contain no-repeat`
  } as any;
});

</script>

<style scoped>
.marker-list-item {
  display: flex;
  align-items: flex-start;
  width: 100%;
}

.marker-symbol {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  height: 31px!important;
  /* width: 20px;
  height: 20px;  */
}

.marker-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
  user-select: none;
  
}

.list-item-text {
  flex: 1;
  font-size: 16px;
  line-height: 1.5;
  color: #374151;
}

.list-item-text :deep(b),
.list-item-text :deep(strong) {
  font-weight: 600;
}

.list-item-title {
  font-weight: 600;
  font-size: 16px;
  color: #1f2937;
  margin-bottom: 4px;
}

/* Адаптивность */
@media (max-width: 768px) {
  .list-item-text {
    font-size: 14px;
  }
}
</style>
